export default {
  "title": "朵朵",
  "main": "158",  // 实时运营报表
  "daylist": "159", // 日运营报表
  "monthlist": "160", // 月运营报表
  "totallist": "161", // 总运营报表
  "ridelist": "155",  // 骑行运营报表
  "userdatalist": "154", // 用户数据分析
  "paylist": "157", // 充值数据分析
  "bikelist": "156", // 车辆数据分析
  "dashboardno": "dashboard-1606211515529-86127",
  "projectno": "proj-xtrace-7e654d5be9aeb17eb6abc78a83f22-cn-hangzhou",
  "customerCensusDay": "190", // 客服工单统计日报表
  "customerCensusMonth": "195",  // 客服工单统计月报表
  "customerCensusTime": "191",  // 客服工单统计时间段 
  "siteCensusDay": "192", // 站点工单统计日报表
  "siteCensusMonth": "194", // 站点工单统计月报表
  "siteCensusTime": "193", // 站点工单统计时间段报表
  "noPassDetail": "189",  // 客服审核不通过明细
  "financialmains": "172", // 财务管理
  "agentdayform": "174",  // 代理商日结算报表
  "controlDataAnalyze" : "197", // 中控数据分析
  "workOrderFaultAnalysis": "216", // 工单故障分析报表
  "LogDashboardno": "dashboard-1614145435698-994766", // 小毛驴用户操作日志
  "ChargingReport": "228", // 换电工作报表
  "bikeAbnormal": "246",  // 车辆异常报表
  "noBoundControlBikeList": "dashboard-1623828494088-315965", // 未绑定中控车辆报表
  "partsMonthlyApplicationReport": "250", // 配件月度申请报表
  "maintainWorkList": "256", // 维修工单统计
  "powerChangeSummary": "257", // 换电工作汇总
  "accessoriesUseReport":"265", // 配件消耗明细报表
  "vehicleAssetsReport": "271", // 车辆资产报表
  "cyclingCardSalesReport":"279", // 骑行卡销售记录
}


// WEBPACK FOOTER //
// ./src/config/duoduo.js